import { render } from "./home.vue?vue&type=template&id=8b8d74e2&scoped=true"
import script from "./home.js?vue&type=script&lang=js&external"
export * from "./home.js?vue&type=script&lang=js&external"

import "./home.vue?vue&type=style&index=0&id=8b8d74e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8d74e2"]])

export default __exports__